import React from 'react'
import ImageWrapper from '../common/ImageWrapper'
import PrimaryButton from '../common/PrimaryButton'
import TertiarySectionLayout from '../layout/TertiarySectionLayout'
import { graphql, useStaticQuery } from 'gatsby'
import AniLink from "gatsby-plugin-transition-link/AniLink"

const TryDemoClass = () => {

    const data = useStaticQuery(query);

    const { allStrapiHomeTryDemoClass: { nodes: HomeTryDemoClass } } = data;

    const { home_tryDemoClass_heading, home_tryDemoClass_subheading, home_tryDemoClass_image, home_tryDemoClass_button } = HomeTryDemoClass[0];
    return (
        <>
            <TertiarySectionLayout>
                <div className="try_demo_class_first">
                    <ImageWrapper ImgUrl={home_tryDemoClass_image.image.url} />
                    <h3 dangerouslySetInnerHTML={{ __html: home_tryDemoClass_heading }}/>
                    <p dangerouslySetInnerHTML={{ __html: home_tryDemoClass_subheading }} />
                    <AniLink fade to={home_tryDemoClass_button.button_redirection}>
                        <PrimaryButton ButtonText={home_tryDemoClass_button.button_text} MaxWidth={13.9375} />
                    </AniLink>
                </div>
            </TertiarySectionLayout>
        </>
    )
}

export const query = graphql`
{
  allStrapiHomeTryDemoClass {
    nodes {
      home_tryDemoClass_heading
      home_tryDemoClass_subheading
      home_tryDemoClass_button {
        button_text
        button_redirection
      }
      home_tryDemoClass_image {
        image {
          url
        }
      }
    }
  }
}
`

export default TryDemoClass